import { triggerAnalytics } from './analytics-utils';

export default class ClickEvents {
  // 7.39.5 My Dashboard Accordion Clicks
  myDashboardAccordion = (value) => {
    triggerAnalytics('pathToProNetwork.my-dashboard.click-accordion', {
      templates: value
    });
  };

  // 7.39.6 Recently Contacted Accordion Actions
  // FLAG FOR REMOVAL
  recentlyContactedAction = (value) => {
    triggerAnalytics('pathToProNetwork.my-dashboard.recently-contacted.click-action', {
      templates: `action>${value}`
    });
  };

  // 7.39.7 Favorites Accordion Actions
  // FLAG FOR REMOVAL
  favoritesAction = (value) => {
    triggerAnalytics('pathToProNetwork.my-dashboard.favorites.click-action', {
      templates: `action>${value}`
    });
  };

  // 7.39.12 Favorites: Find Candidates Here Link
  favoritesPageFindCandidates = () => {
    triggerAnalytics('pathToProNetwork.my-dashboard.favorites.click-find-candidates');
  };

  // 7.39.15 Create New Job Posting Overlay Actions
  createNewJobPostingAction = (value) => {
    triggerAnalytics('pathToProNetwork.my-dashboard.job-postings.create-new.click-actions', {
      templates: value
    });
  };

  // 7.39.19 Profile Image Favorite/Unfavorite Interactions
  profileImageFavoriteInteraction = (favoritedBool) => {
    triggerAnalytics('pathToProNetwork.profile-image.favorite-interaction', {
      favoritedBool
    });
  };

  // 1.2 Your Location Candidate Search
  locationShareDialogInteration = (templates) => {
    triggerAnalytics('pathToProNetwork.shareLocation.findCandidateClick', {
      templates
    });
  };

  // 1.3.1 Recently Contacted Tab
  recentlyContactedAccordionInteraction = () => {
    triggerAnalytics('pathToProNetwork.candidateSearch.recentlyContactedAccordionClick');
  };

  // 1.3.1.1 Recently Contacted Location Filter
  tradeTypeFilter = (value) => {
    return triggerAnalytics('pathToProNetwork.profile-search.filter-interaction', {
      templates: `trade type: ${value.toLowerCase()}`
    });
  };

  // 1.3.1.1 Recently Contacted Location Filter
  experienceLevelFilter = (value) => {
    return triggerAnalytics('pathToProNetwork.profile-search.filter-interaction', {
      templates: `experience level: ${value.toLowerCase()}`
    });
  };

  employmentTypeFilter = (value) => {
    return triggerAnalytics('pathToProNetwork.profile-search.filter-interaction', {
      templates: `employment type: ${value.toLowerCase()}`
    });
  };

  // 1.3.1.1 Recently Contacted Location Filter
  militaryStatusFilter = (value) => {
    return triggerAnalytics('pathToProNetwork.profile-search.filter-interaction', {
      templates: `military status: ${value.toLowerCase()}`
    });
  };

  // 1.3.1.1 Recently Contacted Location Filter
  locationSearchFilter = (...args) => {
    return triggerAnalytics('pathToProNetwork.profile-search.filter-interaction', {
      templates: `filter>location>${args.filter((it) => it !== null && it !== '').join('>').toLowerCase()}`
    });
  };

  // 1.3.1.1 Recently Contacted Location Filter
  availabilityFilter = (value) => {
    return triggerAnalytics('pathToProNetwork.profile-search.filter-interaction', {
      templates: `availability: ${value.toLowerCase()}`
    });
  };

  // 1.3.1.1 Recently Contacted Location Filter
  keywordSearchFilter = () => {
    triggerAnalytics('pathToProNetwork.profile-search.filter-interaction', {
      templates: 'keyword'
    });
  };

  // 1.3.1.2 Recently Contacted Sort
  recentlyContactedSortClick = (field) => {
    triggerAnalytics('pathToProNetwork.dashboard.recentlyContacted.sortChange', { templates: `sort>${field}` });
  };

  // 1.3.1.2 Recently Contacted Sort
  jobPostingsSortClick = (field) => {
    if (field === 'locationText') {
      field = 'location';
    } else if (field === 'postedDate') {
      field = 'date';
    } else if (field === 'applicantCount') {
      field = 'applicant count';
    }
    triggerAnalytics('pathToProNetwork.dashboard.jobPostings.sortChange', { templates: `sort>${field}` });
  };

  // 1.3.1.2 Recently Contacted Sort
  jobPostingsApplicantsSortClick = (field) => {
    triggerAnalytics('pathToProNetwork.dashboard.jobApplicants.sortChange', { templates: `sort>${field}` });
  };

  // 1.4.1 Favorites Tab
  favoriteTabInteraction = () => {
    triggerAnalytics('pathToProNetwork.my-dashboard.favoriteTabClick');
  };

  // 1.4.1.1 Favorites Sort
  favoritesSortClick = (field) => {
    triggerAnalytics('pathToProNetwork.dashboard.favorites.sortChange', { templates: `sort>${field}` });
  };

  /**
   * 1.5.1 Candidate Page Interactions
   * @param {string} name 'contact' || 'drop down' || 'hiring status'
   * @param {string} templates 'email' || 'facebook' || 'instagram' || 'hired' || 'not hired' etc
   */
  candidatePageInteraction = (name, templates, slmCandidateID) => {
    triggerAnalytics('pathToProNetwork.candidateDetails.interaction', { name, templates, slmCandidateID });
  };

  // 1.5.2 Tooltip Interactions
  candidateBadgeProfileInteraction = (action, slmCandidateID) => {
    triggerAnalytics('pathToProNetwork.candidateDetails.tooltip-interaction', {
      templates: `${action}`,
      slmCandidateID
    });
  };

  // 1.6.1 Create New Job Posting Flow
  createNewJobPosting = (templates) => {
    triggerAnalytics('pathToProNetwork.my-dashboard.job-postings.click-create-new', { templates });
  };

  // 1.6.1.2 Create New Job Posting Publish and Save
  createNewJobPostingPublishAndSave = (value) => {
    triggerAnalytics('pathToProNetwork.jobPostings.create-new.publish-and-save', {
      templates: value
    });
  };

  // 1.6.3 Job Postings Actions
  jobPostingsAction = (value) => {
    triggerAnalytics('pathToProNetwork.my-dashboard.job-postings.click-action', {
      templates: `action>${value}`
    });
  };

  // 1.7 Call or Email from Profile Overlay
  contactCandidateFromCandidateOverlay = (templates, candidateId) => {
    return triggerAnalytics('pathToProNetwork.profile-details.contact-candidate', {
      templates,
      candidateId
    });
  };

  // 1.7.1 Job Applicants Tab
  jobApplicantsTabClick = () => {
    triggerAnalytics('pathToProNetwork.dashboard.jobApplicants.tab');
  };

  // 1.7.1.2 Job Applicants Tab Actions
  jobApplicantsAction = (value) => {
    triggerAnalytics('pathToProNetwork.my-dashboard.job-applicants.click-action', {
      templates: `action>${value}`
    });
  };

  // 1.7.2 Posting Details Tab
  jobPostingDetailsTabClick = (templates) => {
    triggerAnalytics('pathToProNetwork.dashboard.postingDetails.tab', { templates });
  };

  /**
   * 1.7.2.1 Posting Details Modifications
   * @param {string} templates `edit` || `mark complete` || `cancel` etc
   */
  postingDetailsModifications = (templates) => {
    triggerAnalytics('pathToProNetwork.jobPostings.postingDetails.modifications', { templates });
  };

  // 1.7.3 Recommendations Tab
  recommendationsTabClick = (templates) => {
    triggerAnalytics('pathToProNetwork.dashboard.recommendations.tab', { templates });
  };

  // 1.7.3.1 Recommendations Tab Actions
  recommendationsTabActionsClick = (templates) => {
    triggerAnalytics('pathToProNetwork.dashboard.recommendations.tab.click-action', { templates });
  };

  // 1.9 PTP Homepage Job Seekers Tab
  jobSeekersButtons = (buttonClicked) => {
    return triggerAnalytics('pathToProNetwork.homepage.job-seekers-buttons', { buttonClicked });
  };

  // 2.2 Landing Page Link Clicks
  landingPageLinkClick = (link) => {
    triggerAnalytics('pathToProNetwork.landing.link-click', {
      templates: link
    });
  };

  // 2.6 Hire this Candidate
  hireCandidate = (candidateId, templates) => {
    return triggerAnalytics('pathToProNetwork.profile-details.hire-click', {
      candidateId,
      templates
    });
  };

  // PTPN2276 - Recently Contacted Candidate Actions
  recentlyContactedCandidateAction = (candidateId, action) => {
    triggerAnalytics('pathToProNetwork.button', {
      candidateId,
      action: 'action',
      id: 'recently contacted',
      name: 'find candidates',
      templates: ['action', action]
    });
  };

  // PTPN2277 - Favorites Candidate Actions
  favoritesCandidateAction = (candidateId, action) => {
    triggerAnalytics('pathToProNetwork.button', {
      candidateId,
      action: 'action',
      id: 'favorites',
      name: 'my dashboard',
      templates: ['action', action]
    });
  };

  // PTPN2278 - Home Page Resource Links Click
  homePageResourceLinksClick = (id) => {
    triggerAnalytics('pathToProNetwork.button', {
      action: 'link',
      id,
      name: 'ptp homepage',
      templates: ['job seekers tab']
    });
  };
}
